import { fetchAppointments } from 'modules/queues/Schedule/actions/fetchAppointments';
import createAction from './';

export const SET_TEXT_SEARCH = createAction('SET_TEXT_SEARCH');
export const SET_SORT_FIELD = createAction('SET_SORT_FIELD');
export const SET_FILTER_BY_APPOINTMENT_STATUS = createAction('SET_FILTER_BY_APPOINTMENT_STATUS');
export const SET_FILTER_BY_LAST_CONVERSATION_STATUS = createAction('SET_FILTER_BY_LAST_CONVERSATION_STATUS');
export const SET_FILTER_BY_SCHEDULE_TYPE = createAction('SET_FILTER_BY_SCHEDULE_TYPE');
export const SET_FILTER_BY_SERVICES = createAction('SET_FILTER_BY_SERVICES');
export const SET_FILTER_BY_DATES = createAction('SET_FILTER_BY_DATES');
export const SET_FILTER_BY_GROUPED_APPOINTMENTS = createAction('SET_FILTER_BY_GROUPED_APPOINTMENTS');
export const SET_FILTER_BY_CONVERSATION_TYPE = createAction('SET_FILTER_BY_CONVERSATION_TYPE');
export const SET_DATERANGE_TYPE = createAction('SET_DATERANGE_TYPE');
export const RESET_ALL_ACCORDEON_FILTERS = createAction('RESET_ALL_ACCORDEON_FILTERS');
export const RESET_SORT = createAction('RESET_SORT');

export const setSortField = field => (dispatch, getState) => {
  const { activeSortField } = getState().queues.schedule.appointmentsFilters;
  let nextActiveSortField = null;

  if (activeSortField.field !== field || activeSortField.direction === 'DESC') {
    nextActiveSortField = { field, direction: 'ASC' };
  } else {
    nextActiveSortField = { field, direction: 'DESC' };
  }

  dispatch({
    type: SET_SORT_FIELD,
    payload: { activeSortField: nextActiveSortField },
  });

  dispatch(fetchAppointments());
};

export const resetSort = () => (dispatch) => {
  dispatch({ type: RESET_SORT });
  dispatch(fetchAppointments());
};

export const setFilterByAppointmentStatus = key => (dispatch, getState) => {
  const { appointmentStatuses } = getState().queues.schedule.appointmentsFilters;

  const nextCheckedStatuses = appointmentStatuses.includes(key)
    ? appointmentStatuses.filter(item => item !== key)
    : [...appointmentStatuses, key];

  dispatch({
    type: SET_FILTER_BY_APPOINTMENT_STATUS,
    payload: { appointmentStatuses: nextCheckedStatuses },
  });

  dispatch(fetchAppointments());
};

export const setFilterByConversationStatus = key => (dispatch, getState) => {
  const { lastConversationStatuses } = getState().queues.schedule.appointmentsFilters;

  const nextCheckedStatuses = lastConversationStatuses.includes(key)
    ? lastConversationStatuses.filter(item => item !== key)
    : [...lastConversationStatuses, key];

  dispatch({
    type: SET_FILTER_BY_LAST_CONVERSATION_STATUS,
    payload: { lastConversationStatuses: nextCheckedStatuses },
  });

  dispatch(fetchAppointments());
};

export const setFilterByScheduleType = key => (dispatch, getState) => {
  const { scheduleTypes } = getState().queues.schedule.appointmentsFilters;

  const nextCheckedScheduleTypes = scheduleTypes.includes(key)
    ? scheduleTypes.filter(item => item !== key)
    : [...scheduleTypes, key];

  dispatch({
    type: SET_FILTER_BY_SCHEDULE_TYPE,
    payload: { scheduleTypes: nextCheckedScheduleTypes },
  });

  dispatch(fetchAppointments());
};

export const setFilterByAppointmentsGroup = key => (dispatch, getState) => {
  const { isGroupAppointment } = getState().queues.schedule.appointmentsFilters;

  const nextCheckedStatuses = isGroupAppointment.includes(key)
    ? isGroupAppointment.filter(item => item !== key)
    : [...isGroupAppointment, key];

  dispatch({
    type: SET_FILTER_BY_GROUPED_APPOINTMENTS,
    payload: { isGroupAppointment: nextCheckedStatuses },
  });

  dispatch(fetchAppointments());
};

export const setFilterByConversationType = key => (dispatch, getState) => {
  const { conversationTypes } = getState().queues.schedule.appointmentsFilters;

  const nextCheckedStatuses = conversationTypes.includes(key)
    ? conversationTypes.filter(item => item !== key)
    : [...conversationTypes, key];

  dispatch({
    type: SET_FILTER_BY_CONVERSATION_TYPE,
    payload: { conversationTypes: nextCheckedStatuses },
  });

  dispatch(fetchAppointments());
};

export const setFilterByServices = serviceId => (dispatch, getState) => {
  const { services } = getState().queues.schedule.appointmentsFilters;

  const nextServices = services.includes(serviceId)
    ? services.filter(item => item !== serviceId)
    : [...services, serviceId];

  dispatch({
    type: SET_FILTER_BY_SERVICES,
    payload: { services: nextServices },
  });

  dispatch(fetchAppointments());
};

export const setTextSearch = value => (dispatch) => {
  dispatch({
    type: SET_TEXT_SEARCH,
    payload: { textSearch: value },
  });

  dispatch(fetchAppointments());
};

export const setFilterByDates = dateRange => (dispatch) => {
  dispatch({
    type: SET_FILTER_BY_DATES,
    payload: { dateRange },
  });

  dispatch(fetchAppointments());
};

export const resetAllAccordeonFilters = () => (dispatch) => {
  dispatch({ type: RESET_ALL_ACCORDEON_FILTERS });
  dispatch(fetchAppointments());
};
